import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";
import {AccountModel} from "../../angular/models/account.model";

export class ShipperAccountSelectAutocompleteCtrl implements IController {

  selectedAccountIds: string[];
  loading: boolean;

  onSelect: Function;

  private searchTerm: any;
  private shipperAccountList: any;
  private selected: any;
  private accountsRef: any;

  constructor(private $accounts: $accountsFactory, public $element, private $log, private $mdSelect) {
  }

  $onInit() {
    this.accountsRef = this.$accounts();
    this.loading = false;
    this.searchTerm = '';
    this.shipperAccountList = [];
    this.selected = [];

    this.loading = true;

    if (this.selectedAccountIds) {
      this.accountsRef.$asyncValues(this.selectedAccountIds)
        .then(
          (accounts: AccountModel[]) => {
            if (accounts && accounts.length) {
              this.shipperAccountList = accounts;
            }
          },
          (error) => {
            this.$log.error('Failed to get shipper accounts', error)
          }
        )
        .finally(() => {
          this.loading = false;
        });
    }

    this.$element.find('input').on('keydown', (ev) => {
      ev.stopPropagation();
    });
  };

  onClose() {
    this.searchTerm = '';
    this.shipperAccountList = _.filter(this.shipperAccountList, (account: AccountModel) => {
      return _.indexOf(this.selectedAccountIds, account.id) !== -1
    });
    this.onSelect({accountIds: this.selectedAccountIds});
  }

  getShipperAccounts() {
    this.loading = true;
    this.accountsRef.$getAll(_.assign({}, {limit: 20, query: this.searchTerm, isDemand: true}))
      .then((shipperAccountIdsList) => {
        return this.accountsRef.$asyncValues(shipperAccountIdsList);
      })
      .then((queryAccounts) => {
        const cleanAccountList = _.filter(this.shipperAccountList, (shipperAccount) => {
          return _.indexOf(this.selectedAccountIds, shipperAccount.id) !== -1
        });
        this.shipperAccountList = _.uniqBy(_.concat(cleanAccountList, queryAccounts), 'id');
      })
      .catch((error) => {
        this.$log.error('Failed to get shipper accounts', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  doneHideSelect() {
    this.onClose();
    this.$mdSelect.hide();
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountSelectAutocomplete', {
    bindings: {
      selectedAccountIds: '<',
      loading: '<',
      onSelect: '&'
    },
    template: require('./shipper-account-select-autocomplete.html').default,
    controller: ShipperAccountSelectAutocompleteCtrl
  });
